/**
 * Remove caracteres especiais e letras de uma string
 */
export const onlyDigits = (value: string): string => {
  return value.replace(/\D/g, "");
};

/**
 * Remove caracteres especiais de uma string
 */
export const onlyAlphaNumeric = (value: string): string => {
  return value.replace(/[^a-zA-Z0-9]/g, "");
};

/**
 * Valida se uma string é um endereço de email válido no formato "john.doe@mail.com"
 */
export const isValidEmail = (email: unknown): boolean => {
  if (typeof email !== "string") return false;

  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email.trim());
};
